import pick from 'lodash-es/pick';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TrackDwell from 'decorators/TrackDwell/TrackDwell';
import { LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import { ec } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { writeSessionStorage } from 'redux/saga/helpers/local-storage';
import { ScheduleItem } from './ScheduleItem';

export class TrackedScheduleItemUnwrapped extends Component {
  onDwell() {
    const {
      searchId,
      pageType,
      position,
      credits,
      classId,
      venueId,
      vertical,
      resultType,
      availabilityData: { creditsReason },
      schedule: { id: scheduleId },
    } = this.props;

    const dateString = new Date().toISOString();

    segment.track('Item Impression', {
      search_id: searchId,
      impression_id: this.makeImpressionId(dateString),
      device_timestamp: dateString,
      category: vertical,
      page_type: pageType,
      schedule_id: scheduleId,
      class_id: classId,
      venue_id: venueId,
      credit_price: credits,
      credits_reasons: creditsReason,
      is_recommended: false,
      position,
      result_type: resultType,
      ec: true,
    });

    ec('Item Impression', {
      search_id: searchId,
      impression_id: this.makeImpressionId(dateString),
      device_timestamp: dateString,
      category: vertical,
      page_type: pageType,
      schedule_id: scheduleId,
      class_id: classId,
      venue_id: venueId,
      credit_price: credits,
      credits_reasons: creditsReason,
      is_recommended: false,
      position,
      result_type: resultType,
    });
  }

  handleScheduleClick = e => {
    this.persistImpressionData();
    e.preventDefault();
  };

  makeImpressionId(dateString) {
    const {
      schedule: { id: scheduleId },
    } = this.props;

    this.impressionId = `${dateString}_${scheduleId}`;

    return this.impressionId;
  }

  persistImpressionData() {
    const {
      searchId,
      pageType,
      credits,
      classId,
      venueId,
      availabilityData: { creditsReason },
      schedule: { id: scheduleId },
    } = this.props;

    writeSessionStorage(`schedule_${scheduleId}`, {
      impression_id: this.impressionId,
      search_id: searchId,
      page_type: pageType,
      class_id: classId,
      venue_id: venueId,
      credit_price: credits,
      credits_reasons: creditsReason,
    });
  }

  render() {
    const scheduleProps = pick(this.props, Object.keys(ScheduleItem.propTypes));

    return <ScheduleItem {...scheduleProps} onCtaClicked={this.handleScheduleClick} />;
  }
}

TrackedScheduleItemUnwrapped.propTypes = {
  pageType: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  credits: PropTypes.number,
  vertical: PropTypes.string,
  searchId: PropTypes.string,
  venueId: PropTypes.number.isRequired,
  classId: PropTypes.number.isRequired,
  resultType: PropTypes.string,
  availabilityData: PropTypes.shape({
    reasonCannotReserve: LocalizableMessageShape,
    creditsReason: PropTypes.string,
  }).isRequired,
  schedule: PropTypes.shape({
    id: PropTypes.number.isRequired,
    display_rating_total: PropTypes.string.isRequired,
    display_rating_average: PropTypes.number.isRequired,
  }),
};

export const TrackedScheduleItem = TrackDwell(TrackedScheduleItemUnwrapped);
